import { localStorageKeys } from "@/enums/common";

const initialState = () => {
  return {
    apiBaseUrl:process.env.VUE_APP_URL,
    serverlessApiBaseUrl:process.env.SERVERLESS_API_BASE_URL,
    clients:[],
    activeClient: {},
    dataSources: [],
    dataSourcesData: {
      googleAnalyticsAccounts: [],
      googleAnalytics4Accounts: [],
      googleAdwordsAccounts: [],
      facebookAccounts: [],
      googleSearchConsoleSites: []
    },
    analyticsGoals:{},
    integrations: [],
    insightResults:[],
    ignoredInsights:[],
    notifications:[],
    popups:{
      insightDetail:{
        isPopupOpen:false,
        data:null,
      },
      insightShare:{
        isPopupOpen:false,
        data:null,
      },
      createNotification:{
        isPopupOpen:false,
        data:null,
      },
      createWebsite:{
        isPopupOpen:false,
        data:null,
      },
      addMember:{
        isPopupOpen:false,
        data:null,
      },
      editMember:{
        isPopupOpen:false,
        data:null,
      },
      createKPI:{
        isPopupOpen:false,
        data:null,
      },
      editKPI:{
        isPopupOpen:false,
        data:null,
      },
      missingCollection:{
        isPopupOpen:false,
        data:null,
      },
      dataSourceChange:{
        isPopupOpen:false,
        data:null,
      },
      reAuthenticate:{
        isPopupOpen:false,
        data:null,
      },
      appsumoAccountUpgrade: {
        isPopupOpen: false,
        data: null,
      },
      requestAnInsight: {
        isPopupOpen: false,
        data: null,
      },
      thankYou: {
        isPopupOpen: false,
        data: null,
      },
      confirmDeleteKPI: {
        isPopupOpen: false,
        data: {},
      },
      confirmDeleteMember: {
        isPopupOpen: false,
        data: {},
      },
      accountPlanUpgrade: {
        isPopupOpen: false,
        data: null,
      },
      insightEdit: {
        isPopupOpen: false,
        data: null,
      },
      changeContactEmail: {
        isPopupOpen: false,
        data: null,
      },
      cancelSubscription: {
        isPopupOpen: false,
        data: null,
      }
    },
    chartsLoadStates:{
      lineChart:{
        isCalled:false,
        isLoaded:false
      },
      gridChart:{
        isLoaded:false,
        isCalled:false,
      },
      treeMapChart:{
        isLoaded:false,
        isCalled:false,
      }
    },
    popupsLoadStates:{
      addMember:{
        isLoaded:false,
        isCalled:false,
      },
      editMember:{
        isLoaded:false,
        isCalled:false,
      },
      missingCollection:{
        isLoaded:false,
        isCalled:false,
      },
      createWebsite:{
        isLoaded:false,
        isCalled:false,
      },
      dataSourceChange:{
        isLoaded:false,
        isCalled:false,
      },
      insightDetail:{
        isLoaded:false,
        isCalled:false,
      },
      insightShare:{
        isLoaded:false,
        isCalled:false,
      },
      createKPI:{
        isLoaded:false,
        isCalled:false,
      },
      editKPI:{
        isLoaded:false,
        isCalled:false,
      },
      createNotification:{
        isLoaded:false,
        isCalled:false,
      },
    },
    apisLoadStates:{},
    loaderStatus:{},
    axiosCancelToken: {
      v1:null,
      v2:null
    },
    axiosCancelStatusCodes: [ 'client_changed' ],
    generalLocalStorageVariables: JSON.parse(localStorage.getItem(localStorageKeys.heybooster)) || {}
  }
}
export default initialState



// WEBPACK FOOTER //
// ./src/store/modules/common/initialState.js